import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
    meta: {
      title: "联系我们",
    },
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/NewsView.vue"),
    meta: {
      title: "新闻动态",
    },
  },
  {
    path: "/newsDesc",
    name: "newsDesc",
    component: () => import("../views/NewsDescView.vue"),
    meta: {
      title: "新闻动态",
    },
  },
  {
    path: "/scheme",
    name: "scheme",
    component: () => import("../views/SchemeView.vue"),
    meta: {
      title: "解决方案",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => {
    // 路由跳转后返回顶部
    return {
      top: 0, // Vue3是top,left
      // Vue2 是 x,y
    };
  },
});
router.beforeEach((to, from, next) => {
  if (to && to.meta && to.meta.title) {
    let title = to.meta.title as any;
    document.title = "沃智达 - " + title;
  }
  next();
});
export default router;
